// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"49ab2eca","51":"5c8a5c8f","79":"b82d3959","170":"c9512103","233":"538ba7a4","361":"fe2fb105","437":"a7f3944a","453":"134b25f1","518":"715fd29a","631":"840b958c","637":"fb87f497","874":"747f1c6d"}[chunkId] + ".chunk.js";
};